import { useMemo } from "react";
import { AddToCartRequestBase } from "../../../mvcapi/models/buyticket/ticketselection";
import { useAddTicketsToCartStore } from "../../../stores";
import { createAddToCartPackageRequest, createAddToCartRequest } from "../../sales-util";
import { useAddPackageToCartStoreExt } from "../../../stores/add-to-cart-stores/add-package-to-cart-store-ext";

// INFO: New sale

/**
 * This convert new sale store stuff to the AddToCartRequest standard
 * @param selectedTickets 
 * @returns 
 */
export function useAddToCartRequest(): AddToCartRequestBase {
    const [ eventDateId, selectedTicketsByEventDateId ] = useAddTicketsToCartStore(s => [ s.eventDateId, s.selectedTicketsByEventDateId ]);
    const [ isAPackageSale, packageId, selectedEventDateIds, packageItems ] = useAddPackageToCartStoreExt(s => [ s.isAPackageSale, s.packageId, s.selectedEventDateIds, s.packageItems ]);

    const addToCartRequest = useMemo(() => {
        if (isAPackageSale()) 
            return createAddToCartPackageRequest(packageId, packageItems,selectedEventDateIds);
        else 
            return createAddToCartRequest(eventDateId, selectedTicketsByEventDateId);
    }, [eventDateId, isAPackageSale, packageId, packageItems, selectedEventDateIds, selectedTicketsByEventDateId]);

    return addToCartRequest;
}
